class Passenger {
  params = {
    ADT: 1,
    CHD: 0,
    INF: 0,
  };
}

export default Passenger;
